<app-toolbar (onToggleBreadcrumbs)="expandBreadcrumb = $event" [sidenavToggle]="sidenavToggled"
             (onToggleSidenav)="toggleSidenav()"></app-toolbar>
<app-breadcrumb [expandBreadcrumb]="expandBreadcrumb"></app-breadcrumb>
<mat-sidenav-container (backdropClick)="toggleSidenav()" fullscreen>
  <mat-sidenav *ngIf="authService.isLoggedIn" class="mat-elevation-z8" position="start" #sidenav
               [mode]="'over'"
               [opened]="screenService.hasLargeScreen()">
    <h3 class="sidenav_header_headline">Menü</h3>
    <mat-nav-list style="width: 300px;">
      <app-nav-list-item *ngFor="let item of constants.NAV_ITEMS"
                         [item]="item"></app-nav-list-item>
    </mat-nav-list>
  </mat-sidenav>
  <mat-sidenav-content class="sidenav_content">
    <router-outlet></router-outlet>
  </mat-sidenav-content>

</mat-sidenav-container>
